export default __webpack_public_path__ + "static/media/flowerTwo.c98bff21.png";